<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Cep</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="border-0" v-if="!isReseller">Revendedor</th>
        <th scope="col" class="border-0">Criado</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in leads" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-lead-edit', params: { leadId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-3">{{ row.zipcode }}</td>
        <td class="td-2">{{ row.phone }}</td>
        <td class="td-2" v-if="!isReseller">{{ (row.reseller) ? row.reseller.name : '-' }}</td>
        <td class="td-2">{{ row.created }}</td>
        <td class="td-2">
          <lead-buttons :lead="row" @toggleSpam="toggleSpam"></lead-buttons>
        </td>
      </tr>
      <tr v-if="leads.length === 0">
        <td colspan="8" class="no-content">Ainda não tem nenhum indicação cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de indicação"
      message="Tem certeza que deseja excluir esse indicação?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import config from '_config';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import LeadButtons from './LeadButtons.vue';
import LeadActions from './LeadActions';
import { _DELETE_LEAD_ } from './LeadModel';

export default {
  name: 'lead-table',
  mixins: [LeadActions],
  components: {
    LeadButtons,
    ConfirmationModal,
  },
  props: {
    leads: {
      type: Array,
    },
  },
  computed: {
    isReseller() {
      const { user } = this.$store.state.user;
      if (user && user.settings.user_type_id === config.RESELLER_TYPE_ID) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      selectLead: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_LEAD_, lead => {
      this.selectLead = lead.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
